import { render, staticRenderFns } from "./planMoneyBack.vue?vue&type=template&id=65871ed2&"
import script from "./planMoneyBack.vue?vue&type=script&lang=js&"
export * from "./planMoneyBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports